import { simplePath } from "../utils.js";
const CREATE_ORG_PATH = "/v2/organization";
const RUD_ORG_PATH = '/v2/organization/:id';
function get_org_rud_path(params) {
    return simplePath(RUD_ORG_PATH, params);
}
export { CREATE_ORG_PATH, RUD_ORG_PATH, get_org_rud_path };
